<script setup lang="ts">
  import StarRatingDisplay from '~renderer/components/StarRatingDisplay.vue'
  import StarRatingInput from '~renderer/components/StarRatingInput.vue'
  import { useIslandTime } from '~renderer/composables/useIslandTime'
  import { onGetIslandVisitorHistory } from '~rpc/procedures/island/onGetIslandVisitorHistory.telefunc'
  import type { InferTelefuncReturn } from '~shared/util/type'

  type IslandVisitRecord = InferTelefuncReturn<typeof onGetIslandVisitorHistory>[number]

  const props = defineProps<{
    visits?: IslandVisitRecord[]
  }>()

  const emit = defineEmits<{
    rate: [visitId: string, rating: number]
    report: [visitId: string]
  }>()
  const { timeAgo } = useIslandTime()

  // MARK: Methods
  const onVisitorRatingClicked = async (visitId: string, rating: number) =>
    emit('rate', visitId, rating)

  const onReportVisitorClicked = async (visitId: string) => emit('report', visitId)
</script>

<template>
  <!-- Body Section -->
  <div v-if="visits?.length" class="mt-6 mb-1 flex min-h-0 flex-col items-center gap-4">
    <!-- Queue List -->
    <div class="lg:max-none relative max-h-60 w-full flex-1 space-y-2 overflow-y-auto">
      <div v-for="visit in visits" class="grid grid-cols-[3rem_5rem_1fr_7.5rem] items-center gap-2">
        <div class="flex items-center gap-2">
          <a
            class="cursor-pointer text-white/40 hover:text-white"
            target="_blank"
            :href="`/user/${visit.userId}`"
          >
            <i-fa7-solid-arrow-up-right-from-square class="size-4" />
          </a>
          <button
            class="cursor-pointer text-white/40 hover:text-white"
            @click="onReportVisitorClicked(visit.visitId)"
          >
            <i-fa7-solid-flag class="size-4" />
          </button>
        </div>

        <div class="text-left">
          <span class="text-tan-400 ml-2 italic">{{ timeAgo(visit.visitedAt) }}</span>
        </div>

        <div class="truncate">
          <span class="font-bold text-white">{{ visit.name }}</span>
        </div>

        <div class="flex items-center gap-2">
          <StarRatingInput
            v-if="!visit.rating || visit.rating === 0"
            :size="5"
            @input="onVisitorRatingClicked(visit.visitId, $event)"
          />
          <StarRatingDisplay v-else :rating="visit.rating" :size="5" />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="text-md my-6 text-center italic">
    <p>Your island hasn't had any visitors yet!</p>
  </div>
</template>
